import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ './views/Home')
    },
    {
      path: '/response/:id?',
      name: 'response',
      component: () => import(/* webpackChunkName: "response" */ './views/response.vue')
    },
    {
      path: '/failed/:id?',
      name: 'failed',
      component: () => import(/* webpackChunkName: "failled" */ './views/responsefailed.vue'),
    },
    {
      path: '/cgv_mobile',
      name: 'cgv_mobile',
      component: () => import(/* webpackChunkName: "cgv_mobile" */ './views/cgv_mobile.vue')
    },
    {
      path: '/res/:id?',
      name: 'newcallback',
      component: () => import(/* webpackChunkName: "cgv_mobile" */ './views/newcallback.vue')
    }
  ]
})
